import { render, staticRenderFns } from "./Imprint.vue?vue&type=template&id=6c9d434a&scoped=true"
var script = {}
import style0 from "./Imprint.vue?vue&type=style&index=0&id=6c9d434a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9d434a",
  null
  
)

export default component.exports